import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useAccess } from "../useAccess";

/** Redirects non-Layer users away from a staff-only route. */
export const useInternalOnlyRedirect = (redirectTo: string) => {
  const { isInternalUser } = useAccess();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isInternalUser && redirectTo) {
      navigate(redirectTo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInternalUser, redirectTo]);
};
